module.exports = __webpack_public_path__ + "static/info-section-bg1-deedde15d8b25473474da7d4ac6d9c03.jpg";